// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSUISimpleContainer/index.less
// module id = 1388
// module chunks = 42